angular.module("labApp").factory("GenericStoreFactory", ["$resource", function ($resource) {
    return $resource('api/v1.0/store/all-stores-for-user/', {
        query: {
            isArray: true
        }
    });
}]);

